export default class User {
    first_name;
    last_name;
    avatar;
    email;
    phone;
    admin;

    constructor(props) {
        Object.assign(this, props);
    }
}
